import React, { useState } from "react";
import "./login.css";
import { jwtDecode } from 'jwt-decode';

export const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async () => {
        try {
            const response = await fetch('https://api.carteldemanhwas.net/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ correo_electronico: email, contrasena: password })
            });
    
            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('token', data.token);  // Almacenar el token en localStorage
                const decoded = jwtDecode(data.token);
                console.log('Perfil del usuario:', decoded.perfil);
                window.location.href = '/';  // Redirigir a la página de inicio
            } else {
                alert("Error en el inicio de sesión");
            }
        } catch (error) {
            console.error("Error al iniciar sesión:", error);
        }
    };

    const handleGoogleLogin = () => {
        window.location.href = 'https://api.carteldemanhwas.net/auth/google';
    };

    return (
        <div className="todologin">
            <div>
                <section>
                    <div className="contenedorlogin">
                        <div className="formulario">
                            <form action="#" onSubmit={(e) => e.preventDefault()}>
                                <h2>Iniciar Sesión</h2>

                                <div className="input-contenedor">
                                    <i className="fa-solid fa-envelope"></i>
                                    <input 
                                        type="email" 
                                        required 
                                        value={email} 
                                        onChange={(e) => setEmail(e.target.value)} 
                                    />
                                    <label>Email</label>
                                </div>

                                <div className="input-contenedor">
                                    <i className="fa-solid fa-lock"></i>
                                    <input 
                                        type="password" 
                                        required 
                                        value={password} 
                                        onChange={(e) => setPassword(e.target.value)} 
                                    />
                                    <label>Contraseña</label>
                                </div>

                                <div className="olvidar">
                                    <label>
                                        <input type="checkbox" /> Recordar -
                                        <a href="/iniciarSesion"> Olvidé la Contraseña</a>
                                    </label>
                                </div>

                                <button type="button" onClick={handleLogin}>Acceder</button>
                                <button type="button" onClick={handleGoogleLogin}>
                                    <i className="fa-brands fa-google"></i>
                                </button>

                                <div className="registrar">
                                    <p>No Tengo Cuenta <a href="/CrearCuenta">Crear Una</a></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};
